import { RootState } from 'common/redux/core/root.reducer';

export const getSelectedFiles = (state: RootState) => state.fileUpload.selectedFiles;

export const getUploadingFiles = (state: RootState) => state.fileUpload.uploadingFiles;

export const getUploadModalVisibility = (state: RootState) => state.fileUpload.isVisible;

export const getFileUploadResponseStatus = (state: RootState) =>
    state.fileUpload.uploadResponse.status;

export const getSyncDetails = (state: RootState) => state.fileUpload.syncDetails.data;
export const getSyncDetailsStatus = (state: RootState) => state.fileUpload.syncDetails.status;

export const getUploadStatus = (state: RootState) => state.fileUpload.uploadFileDetails;
